<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">需求分类分布</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>业务需求需求分类分布数据统计</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <!-- <div slot="extra">
        <a-radio-group v-model="showModal" button-style="solid" size="small" @change="getTaskPointRank">
          <a-radio-button value="bar"> 柱状图 </a-radio-button>
          <a-radio-button value="pie"> 圆饼图 </a-radio-button>
        </a-radio-group>
      </div> -->
      <div ref="countRef" :style="{ height: height, width: width }" />
    </a-card>
  </div>
</template>
<script>
import { requirementScore } from '@/utils/dictionary';
import { getBrScopeCollecter } from '@/api/business/requirement';
const echarts = require('echarts/lib/echarts');
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      requirementScore,
      showModal: 'bar',
      loading: true,
      myChart: null,
      optionPie: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          show: false
        },
        series: [
          {
            name: '需求总数',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [],
            label: {
              formatter: '{b} ({d}%)',
              fontSize: 12
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      },
      data: []
    };
  },
  watch: {
    filterForm() {
      this.getTaskPointRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    // const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/pie'); // 饼图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(this.$refs.countRef);

    this.getTaskPointRank();
  },
  beforeDestroy() {
    // 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    changeType() {

    },
    drawChart() {
      this.myChart.setOption(this.optionPie, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getTaskPointRank() {
      this.loading = true;
      getBrScopeCollecter({ ...this.filterForm })
        .then(res => {
          this.data = res.data;
          const dataList = this.requirementScore || [];

          const groupBy = this.data.reduce((result, currentItem) => {
            const groupKey = currentItem.name2;
            if (!result[groupKey]) {
              result[groupKey] = 0;
            }
            result[groupKey] += currentItem.count;
            return result;
          }, {});

          const datas = [];
          dataList.forEach(el => {
            const d = groupBy[el.value + ''];
            if (d) {
              datas.push({
                value: d,
                name: el.label
              });
            } else {
              datas.push({
                value: 0,
                name: el.label
              });
            }
          });
          this.optionPie.series[0].data = datas;

          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
.a1{
  color: #f35653;
}
</style>
